import {
  FETCH_VM_STOCK_AVAILABILITY,
  RESET_VM_STOCK_AVAILABILITY,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const vmStockAvailabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_STOCK_AVAILABILITY:
      return { data: action.payload };
    case RESET_VM_STOCK_AVAILABILITY:
      return initialState;
    default:
      return state;
  }
};

export default vmStockAvailabilityReducer;
